import { observable, computed, action, autorun } from "mobx";

class UiStore {

  constructor (rootStore) {
    this.rootStore = rootStore
    this.service = rootStore.service
  }

  @observable successMessages = []
  @observable infoMessages = []
  @observable warningMessages = []
  @observable dangerMessages = []

  @observable isLoading = false;
  @observable contanctFormState = 'INSERTING';
  @observable collapsedPanel = true

  @action
  toggleContactPanel () {
    this.collapsedPanel = !this.collapsedPanel
  }

  @computed get messagesCount () {
    return this.successMessages.length + this.infoMessages.length + this.warningMessages.length + this.dangerMessages.length;
  }

  @action
  addSuccessMessage (message) {
    this.successMessages.push(message)
  }

  @action
  addInfoMessage (message) {
    this.infoMessages.push(message)
  }

  @action
  addWarningMessage (message) {
    this.warningMessages.push(message)
  }

  @action
  addDangerMessage (message) {
    this.dangerMessages.push(message)
  }

  @action
  clearMessages () {
    this.successMessages = this.successMessages.filter(elem => elem.persist)
    this.infoMessages = this.infoMessages.filter(elem => elem.persist)
    this.warningMessages = this.warningMessages.filter(elem => elem.persist)
    this.dangerMessages = this.dangerMessages.filter(elem => elem.persist)
  }

  @action
  lowerCaseError = (error) => {
    if (error !== '') {
      let prima = error.charAt(0).toUpperCase();
      let string = error.slice(1).toLowerCase();
      let err = prima + string;
      return err
    } else {
      return ''
    }
  }

}

export default UiStore;